import LinkComponent from './Link'

export default LinkComponent
